export default {
  questions: {
    openConversational: {
      openEndPlaceholder: 'Veuillez entrer votre texte ici',
      conversationalPlaceholder: 'Veuillez entrer votre réponse ici',
      conversationClosed: 'Conversation fermée.',
      conversationalDisclaimer: 'Les questions de suivi seront générées par l\'IA en fonction de vos réponses.'
    },
    openText: {
      openEndPlaceholder: 'Veuillez entrer votre texte ici'
    },
    multiText: {
      fieldPlaceholder: 'Réponse {number}',
      instruction: 'Entrez au moins {count} réponse ci-dessous, une par zone de texte | Entrez au moins {count} réponses ci-dessous, une par zone de texte',
      instructionWithoutMinimum: 'Entrez vos réponses ci-dessous, une par zone de texte',
      minimumEntries: 'Veuillez entrer au moins {count} réponse pour continuer. | Veuillez entrer au moins {count} réponses pour continuer.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Marque {number}',
        minimumEntries: 'Veuillez entrer au moins {count} marque pour continuer. | Veuillez entrer au moins {count} marques pour continuer.'
      }
    },
    multiselect: {
      caption: "Sélectionnez tout ce qui s'applique"
    },
    rankOrder: {
      enterRankOrder: "Entrez l'ordre de classement",
      placeholder: "Glissez vos choix ici pour les classer"
    },
    openNumeric: {
      label: "Ouvrir le champ numérique"
    },
    complete: {
      message: "Merci d'avoir complété ce sondage."
    },
    openVideo: {
      warning: "Veuillez enregistrer une vidéo avant de poursuivre.",
      uploadStatusUploading: "Veuillez patienter pendant que nous traitons votre vidéo avant de poursuivre...",
      uploadStatusSuccess: "Téléversement réussi, vous pouvez continuer.",
      uploadStatusError: "Téléversement non terminé, veuillez réessayer."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Veuillez saisir une adresse courriel valide',
      text_invalid_phone: 'Veuillez saisir un numéro de téléphone valide',
      text_invalid_us_zip: 'Veuillez saisir un code postal américain (ZIP) valide',
      text_invalid_ca_postal: 'Veuillez saisir un code postal canadien valide',
      text_invalid_uk_postal: 'Veuillez saisir un code postal britannique valide',
      text_invalid_custom: 'Veuillez saisir une valeur valide pour {fieldName}',
      text_min_chars: 'Veuillez saisir au moins {min} caractères',
      text_max_chars: 'Veuillez ne pas saisir plus de {max} caractères',
      text_alpha_not_allowed: 'Seuls les chiffres sont autorisés',
      text_numeric_not_allowed: 'Seules les lettres sont autorisées'
    },
    external: {
      invalid: 'La réponse à cette question n\'est pas valide.',
      singlechoice_required: 'Cette question doit être répondue.',
      required: 'Cette question doit être répondue.',
      numeric_required: 'Veuillez sélectionner une évaluation avant de continuer.',
      text_required: 'Veuillez saisir une réponse avant de continuer.',
      bigtext_required: 'Veuillez saisir une réponse avant de continuer.',
      singlechoiceother_incomplete: 'Veuillez saisir une réponse avant de continuer.',
      multiselectother_incomplete: 'Veuillez saisir une réponse avant de continuer.',
      numeric_invalid: 'Veuillez saisir un nombre valide avant de continuer.',
      radiogrid_required: 'Veuillez sélectionner une option pour chaque ligne avant de continuer.',
      incomplete: 'Veuillez répondre à cette question avant de continuer.',
      multiselect_min: 'Veuillez sélectionner au moins {value} options avant de continuer.',
      multiselect_max: 'Veuillez ne pas sélectionner plus de {value} options avant de continuer.',
      multiselectother_min: 'Veuillez sélectionner au moins {value} options avant de continuer.',
      multiselectother_max: 'Veuillez ne pas sélectionner plus de {value} options avant de continuer.',
      multiselectgrid_min: 'Veuillez sélectionner au moins {value} options pour chaque ligne avant de continuer.',
      multiselectgrid_max: 'Veuillez ne pas sélectionner plus de {value} options pour chaque ligne avant de continuer.',
      rankorder_min: 'Veuillez classer au moins {value} éléments avant de continuer.',
      rankorder_max: 'Veuillez ne pas classer plus de {value} éléments avant de continuer.'
    }
  }
}
